'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ValueHighlight {
    id: number;
    icon: string;
    title: string;
    description: string;
    color: string;
}

const StudentValueHighlights: React.FC = () => {
    const highlights: ValueHighlight[] = [
        {
            id: 1,
            icon: 'AcademicCapIcon',
            title: 'Personalized Learning Paths',
            description: 'AI-powered curriculum tailored to your goals, skill level, and learning pace for maximum growth.',
            color: 'text-primary'
        },
        {
            id: 2,
            icon: 'ChartBarIcon',
            title: 'Track Your Progress',
            description: 'Real-time analytics and insights help you understand your strengths and areas for improvement.',
            color: 'text-accent'
        },
        {
            id: 3,
            icon: 'UserGroupIcon',
            title: 'Collaborative Learning',
            description: 'Join study groups, participate in discussions, and learn from peers worldwide.',
            color: 'text-secondary'
        },
        {
            id: 4,
            icon: 'TrophyIcon',
            title: 'Earn Recognition',
            description: 'Unlock achievements, certificates, and industry-recognized credentials as you progress.',
            color: 'text-warning'
        }
    ];

    return (
        <section className="py-16 bg-surface">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">
                        Why Students Choose AstikLearn
                    </h2>
                    <p className="text-lg text-text-secondary max-w-3xl mx-auto">
                        Transform your learning experience with tools and resources designed specifically for student success
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {highlights.map((highlight) => (
                        <div
                            key={highlight.id}
                            className="glass glass-border rounded-lg p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                        >
                            <div className={`mb-4 ${highlight.color}`}>
                                <Icon name={highlight.icon} size={40} variant="solid" />
                            </div>
                            <h3 className="text-xl font-semibold text-text-primary mb-3">
                                {highlight.title}
                            </h3>
                            <p className="text-text-secondary leading-relaxed">
                                {highlight.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default StudentValueHighlights;